module.exports = __webpack_public_path__ + "img/svg/youtube.d92f8e09ff363ecd0f55df68dd5176dd.svg";